import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledKpi = styled.div`
  padding: 18px 20px;
  background: var(--ds-surface);
  border-radius: 14px;
  box-shadow: var(--ds-shadow-card);

  .kpi-label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 500;
    color: var(--dimGray);
  }

  .kpi-dot {
    width: 10px;
    height: 10px;
    border-radius: 3px;
    background: ${({ $color }) => $color};
  }

  .kpi-value {
    margin-top: 8px;
    font-size: 26px;
    font-weight: 700;
    letter-spacing: -0.02em;
  }
`;

/**
 * Key figure displayed above the finances charts.
 * @component
 * @param {Object} props - The component props.
 * @param {string} props.label - Label of the figure.
 * @param {string} props.value - Formatted value.
 * @param {string} props.color - Color of the dot.
 * @returns {JSX.Element} - The KpiCard component.
 */
export const KpiCard = ({ label, value, color }) => (
  <StyledKpi $color={color}>
    <div className="kpi-label">
      <span className="kpi-dot" />
      {label}
    </div>
    <div className="kpi-value">{value}</div>
  </StyledKpi>
);

KpiCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired
};
